import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

export type ActorKind = 'system' | 'xemex' | 'user';

export function actorKindOf(actor: string | null | undefined): ActorKind {
  switch (actor?.toLowerCase()) {
    case 'system':
      return 'system';
    case 'xemex':
      return 'xemex';
    default:
      return 'user';
  }
}

/** The one label for who did something. The backend already sends `xemex` in place of any Xemex
 *  employee, so a customer never receives that name; a customer's own user keeps their name.
 *  Every screen that shows an actor uses this. */
@Pipe({
  name: 'actorName',
  pure: false,
})
export class ActorNamePipe implements PipeTransform {
  private readonly translate = inject(TranslatePipe);

  transform(actor: string | null | undefined): string {
    const kind = actorKindOf(actor);
    const name = actor?.trim();
    if (kind === 'user' && name) return name;
    return this.translate.transform(`general.actor.${kind}`);
  }
}
